export default "__VITE_ASSET__Bxqy0J2n__"